import * as React from 'react'

import xor from 'lodash/xor'

const useMembers: () => [
  number[],
  (id: number | null | undefined) => void,
  (ids: number[]) => void
] = () => {
  const [memberIds, setMemberIds] = React.useState<number[]>([])

  const setMember = (id: number | null | undefined) => {
    if (!id) return

    setMemberIds(xor(memberIds, [id]))
  }

  const setMembers = (ids: number[]) => setMemberIds(ids)

  return [memberIds, setMember, setMembers]
}

export default useMembers
